<template>
  <div class="cta">
    <h5 class="tx-wg-medium" v-if="size === 'normal'">{{ cta }}</h5>
    <h4 class="tx-wg-medium" v-if="size === 'big'">{{ cta }}</h4>
    <img
      :src="require(`@/assets/icons/arrow-${type}.svg`)"
      svg-inline
      class="cta-icon"
      :class="type"
    />
  </div>
</template>

<script>
export default {
  name: 'CTA',
  props: {
    cta: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'normal'
    },
    type: {
      type: String,
      default: 'circle'
    }
  }
};
</script>

<style lang="scss" scoped>
.cta {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  .cta-icon {
    cursor: pointer;
    display: block;
    transition: transform 0.3s;
  }
  h5,
  h4 {
    cursor: pointer;
    display: inline-block;
    margin-right: 1rem;
  }
  &:hover {
    .cta-icon:not(.circle) {
      transform: translateX(20%);
    }
  }
}
</style>
